const Colors = {
  orangePrimary: "#F5801C",
  orangeSecondary: "#D56C12",
  orangeterTertiary: "#FFAE3A",
  white: "#FFFFFF",
  borderColor: "#E3E3E3",
  TypoNormal: "#6B5E5E",
  linkColor: "#117DA8",
  typoblue: "#495E9C",
  typoblue2: "#4094B5",
  greyFont: "#615D5D",
  tinyFont: "#B54B39",
  tinyButton: "#CF604D",
  tinyButtonHover: "#EF664F",
  masterFont: "#346B6B",
  masterButton: "#3E836C",
  masterButtonHover: "#1B9A2E",
  logicFont: "#865612",
  //logicButton:'#865612'
  logicButtonHover: "#865612",
  typoblue3: "#405861",
  getInTouchBg: "#FFF2F2",
  getInTouchButton: "#FD8486",
  getInTouchFont: "#5F5F5F",
  getInTouchButtonHover: "#DF7475",
  yellowflake: "#DFB724",
  orengeflake: "#F5801C",
  redflake: "#D32D41",
  greenflake: "#53BA6F",
  gamelevelgrey: "#D5C5C5",
};

export default Colors;
